import React, { Component } from 'react';
import { 
    Button,
    CircularProgress,
} from '@material-ui/core';
import { downloadCSV } from 'react-admin';
import { API_BASE_URL } from '../config';
import { unparse as convertToCSV } from 'papaparse/papaparse';

class CustomExport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            endPoint: props.endPoint,
            expanded: false,
            options: 'all',
            fetching: false,
            filter: props.filter,
            filename: props.filename
        };
    }

    handleExportClick() {
        this.setState({ fetching: true });
        let token = localStorage.getItem('token');
        if (token) {
            fetch(`${API_BASE_URL}/${this.state.endPoint}?options=${this.state.options}&filter=${JSON.stringify(this.state.filter)}`, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization' : `Bearer ${token}`
                })
            }).then(response => {
                this.setState({ fetching: false });
                return response.json();
            }).then(data => {
                let csvConfig = 
                {
                    quotes: false, //or array of booleans
                    quoteChar: '"',
                    escapeChar: '"',
                    delimiter: ";",
                    header: false,
                    newline: "\r\n",
                    skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
                };
                //const header = "Id;Email;Email Domain;Is External;First Name;Last Name;Country;City;Company;Created;Last Activity;User Number;License;User Group;Status;Pandora;General Pandora;Prices;Fluid Editor;Adv. Datasheet;New Sale Pricelist;Branch;Level;Regions;LPL;\r\n";
                let convertedCsv = /*header +*/ convertToCSV(data, csvConfig);
                downloadCSV(convertedCsv, this.state.filename);
            }).catch(err => {
                console.log(err);
                this.setState({ fetching: false });
            });
        }
    }

    render() {
        return (
            <Button 
            enabled={this.state.fetching ? 'false' : 'true' }
            color="primary" 
            variant="contained" 
            size='small' 
            onClick={() => this.handleExportClick()}>
                { this.state.fetching ? <CircularProgress /> : 'Export' } 
            </Button>
        )
    }
}
export {CustomExport};
